const URL = {
	INDEX: '',
	HOME: '/partner',
	HOME2: ':partner/:route/:citation',
	HOME3: ':partner/:citation',
	// THANKYOU: '/thankyou',
	PAYMENT_RESPONSE: ':partner/paymentResponse',
	PAYMENT_FAILED: ':partner/paymentFailed',

	PAYMENT_RESPONSE2: ':partner/paymentResponse/:citation',
	PAYMENT_FAILED2: ':partner/paymentFailed/:citation',
	// for the previous history 
	PREVIOUS_HISTORY_CITAYION: ':partner/previousHistory/:citation',
	// 

	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react',
	PARKENGAGE_LOGO_URL: 'https://parkengage.com/static/media/logo.8ed76367.svg',
	
	// EOS-973
	FISERV_IFRAME_FORMAT_URL: 'cardnumbernumericonly=true&useexpiryfield=true&useexpiry=true&usecvv=true&enhancedresponse=true&formatinput=true&maskfirsttwo=true&placeholder=Enter%20Card%20Number&cardlabel=Card%20Number%20*&cardinputmaxlength=19&expirylabel=Expiry%20Date%20*&cvvlabel=CVV%20*&placeholdermonth=MM&placeholderyear=YYYY&invalidinputevent=true&invalidcvvevent=true&invalidexpiryevent=true&onFormValid=true&placeholdercvv=511',
}

export default URL
